export const SHIRT_REQUEST_PENDING = "SHIRT_REQUEST_PENDING";
export const SHIRT_DATA_FAILURE = "SHIRT_DATA_FAILURE";

//Get Shoes Data
export const GET_SHIRT_REQUEST_SUCCESSFUL = "GET SHIRT_REQUEST_SUCCESSFUL";

//Post Shoes Data
export const POST_SHIRT_REQUEST_SUCCESSFUL = "POST_SHIRT_REQUEST_SUCCESSFUL";